import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { parse, stringify } from 'qs';
import classnames from 'classnames';

import './page-size.scss';

@withRouter
export class PageSize extends React.Component {
  static propTypes = {
    list: PropTypes.arrayOf(PropTypes.string),
    initialValue: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string,
    urlParamName: PropTypes.string,
    customPageSizeClick: PropTypes.func,
    // classNames
    className: PropTypes.string,
  };

  static defaultProps = {
    list: [],
    label: 'Page size:',
    urlParamName: 'PageSize',
    // classNames
    className: '',
  };

  handleClick = (newPageSize) => {
    const { customPageClick } = this.props;
    if (typeof customPageClick === 'function') {
      return customPageClick(newPageSize);
    }
    const { history, urlParamName } = this.props;
    const { location = {} } = history;
    const { search = '', pathname } = location;
    const queries = parse(search, { ignoreQueryPrefix: true }) || {};
    queries[urlParamName] = newPageSize;
    delete queries.Page;
    const queriesString = `?${stringify(queries)}`;
    history.push(`${pathname}${queriesString}`);
  };

  render() {
    const {
      className,
      history,
      label,
      list,
      initialValue,
      urlParamName,
      value,
    } = this.props;
    const { location = {} } = history;
    const { search = '' } = location;
    const queries = parse(search, { ignoreQueryPrefix: true }) || {};

    const pageSizeValue = value || queries[urlParamName] || initialValue;

    return (
      <div className={classnames('page-size', className)}>
        <div className="bold">{label}</div>
        {list.map((listItem, index) => (
          <div
            key={index}
            className={classnames('page-size__element', {
              _active: pageSizeValue === listItem,
            })}
            onClick={
              pageSizeValue === listItem
                ? () => {}
                : () => this.handleClick(listItem)
            }
          >
            {listItem}
          </div>
        ))}
      </div>
    );
  }
}
